// API Configuration
export const EXECUTE_URL = "/m4ai/api/v1/agent-systems/staffingagentssplit/execute?version=2";

// Queries
export const STAFFING_QUERY = "Analyze the PDF 'Projektunterstützung_MBSE.pdf' and staff the project with cost calculation.";

// UI Constants
export const TEXTAREA_CONFIG = {
  MAX_LINES: 8,
  LINE_HEIGHT: 24,
  get MAX_HEIGHT() { return this.MAX_LINES * this.LINE_HEIGHT; }, // 192px
  MIN_HEIGHT: '3rem'
};

// Animation Timings
export const ANIMATION_DURATIONS = {
  COST_PRINT_DELAY: 25, // ms between lines when printing cost estimation
  STATE_RESET_DELAY: 50   // ms delay for state updates to complete
};

// Panel IDs
export const PANEL_IDS = {
  ANALYSIS: 'analysis',
  STAFFING: 'staffing',
  COST: 'cost',
  TOOLS: 'tools'
};